import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import {
    CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Document,
    CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment,
} from "../../../../../../generated";
import { DecisionDetail } from "./decision-detail";

interface DecisionDetailContainerProps {
  caseId: string;
}

export const DecisionDetailContainer: React.FC<DecisionDetailContainerProps> = (props) => {
  const {
    data: caseDecisionData,
    loading: caseDecisionLoading,
    error: caseDecisionError,
  } = useQuery(
    CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Document,
    {
      variables: {
        identityVerificationCaseV1Id: props?.caseId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={caseDecisionLoading}
      hasData={caseDecisionData}
      error={caseDecisionError}
      hasDataComponent={
        <DecisionDetail
          data={
            caseDecisionData?.identityVerificationCaseV1?.caseDetails as CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment
          }
        />
      }
    />
  );
};
